import { TestStatus } from '@shared/types/database'

export interface AudienceMap {
  [key: string]: {
    id: string,
    title: string,
    isLegacy?: boolean
  }
}

export interface ProjectCardData {
  id: string,
  testCount: number,
  testStatusCount: Record<TestStatus, number>,
  audiences: AudienceMap,
  reports: any[],
  ids: string[],
  tags: string[]
  title: string,
  description: string,
  lastModified: number | undefined,
}

export type ButtonMode = 'primary' | 'secondary' | 'tertiary' | 'link' | 'danger'
export type ButtonSize = 'small' | 'normal'
export type ButtonType = 'submit' | 'reset' | 'button'

export interface SelectOption {
  label: string | number;
  value: string | number | null;
}

export interface IScale {
  minRating: number
  maxRating: number
  minLabel: string
  maxLabel: string
  naOption: boolean
}

export type TideAsset = TideImageAsset | TideVideoAsset | TideTextAsset

export interface TideImageAsset {
  type: AssetType.IMAGE,
  url: string,
  viewed: boolean,
  forceOpen?: boolean
}

export interface TideVideoAsset {
  type: AssetType.VIDEO,
  url: string,
  viewed: boolean,
  title?: string,
  forceOpen?: boolean
}

export interface TideTextAsset {
  type: AssetType.TEXT,
  text: string,
  viewed: boolean,
  title?: string,
  forceOpen?: boolean
}

export enum AssetType {
  IMAGE = 'image',
  VIDEO = 'video',
  TEXT = 'text'
}

export enum ToastState {
  WARNING = 'warning',
  DANGER= 'danger',
  SAFETY= 'safety'
}
